import { FC, PropsWithChildren } from 'react';
import { Chip, ChipProps, Tooltip } from '@mui/material';

export interface DefaultChipProps extends ChipProps {
  title?: string;
}

export const DefaultChip: FC<PropsWithChildren<DefaultChipProps>> = ({ sx, label, title, ...rest }) => {
  const tooltipTitle = title ?? label?.toString();

  return (
    <Tooltip placement="right-start" title={tooltipTitle}>
      <Chip
        size="small"
        label={label}
        sx={{
          border: 1,
          fontWeight: 'bold',
          lineHeight: '14px',
          fontSize: 'caption.fontSize',
          ...sx,
        }}
        {...rest}
      />
    </Tooltip>
  );
};
